// icons/UserCircleIcon.js

const UserCircleIcon = ({
  size = 72,
  bgColor = "#F1EEFF",
  stroke = "#5B4DFF"
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "9999px",
        background: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <svg
        width={40}
        height={40}
        viewBox="0 0 24 24"
        fill="none"
      >
        {/* head */}
        <circle
          cx="12"
          cy="8"
          r="3.5"
          stroke={stroke}
          strokeWidth="2"
        />

        {/* body */}
        <path
          d="M5.5 18C5.5 14.9 8 13 12 13C16 13 18.5 14.9 18.5 18"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default UserCircleIcon;